import CreateResourceInteractor from "../../core/interactor/app/crud/CreateResourceInteractor";
import Constants from "../common/Constants";

import { IOrganisation } from "../model/Organisation";
import OrganisationMapper from "../service/OrganisationMapper";
import OrganisationParamMapper from "../service/OrgansationParamMapper";

export default class CreateOrganisationInteractor {
  private createResource: CreateResourceInteractor<IOrganisation>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(model: IOrganisation) {
    return this.createResource.execute(
      Constants.organisationsPath,
      OrganisationMapper,
      OrganisationParamMapper,
      model
    );
  }
}
